// extracted by mini-css-extract-plugin
export var audioPlayer = "_pn-0";